module.exports = __webpack_public_path__ + "img/nc.df1be377.svg";